module.exports = __webpack_public_path__ + "img/thumb_20.f744571b.jpg";